// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-left-right-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.5 11.5L13.5 7.50001L9.5 3.5M12.25 7.5H3.5M14.5 20.5L10.5 16.5L14.5 12.5M11.75 16.5H20.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowLeftRight2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-left-right-2',
    ref,
    icon: element,
  },
));

ArrowLeftRight2Icon.displayName = 'ArrowLeftRight2Icon';

export default ArrowLeftRight2Icon;
